import { render, staticRenderFns } from "./ViewTabelaSensorVirtualMensalForm.vue?vue&type=template&id=21ee5707&scoped=true&"
import script from "./ViewTabelaSensorVirtualMensalForm.vue?vue&type=script&lang=js&"
export * from "./ViewTabelaSensorVirtualMensalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ee5707",
  null
  
)

export default component.exports